import type { ReactNode } from "react";
import { cx } from "../cx";
import { Icon } from "../Icon";
import styles from "./Chip.module.css";

export type ChipTone = "neutral" | "success" | "incomplete" | "error" | "info" | "deleted";

export interface ChipProps {
  children: ReactNode;
  tone?: ChipTone;
  icon?: ReactNode;
  /** Shows an x; the label names what is removed for screen readers. */
  onRemove?: () => void;
  removeLabel?: string;
  className?: string;
}

export function Chip({ children, tone = "neutral", icon, onRemove, removeLabel, className }: ChipProps) {
  return (
    <span className={cx(styles.chip, styles[tone], className)}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.label}>{children}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.remove}
          aria-label={removeLabel ?? (typeof children === "string" ? `Remove ${children}` : "Remove")}
          onClick={onRemove}
        >
          <Icon name="close" size={12} strokeWidth={2} />
        </button>
      )}
    </span>
  );
}

/** Tag pill as shown in tag pickers and entry rows: neutral chip, removable. */
export function Tag(props: Omit<ChipProps, "tone">) {
  return <Chip {...props} tone="neutral" />;
}
